/**
 * Enforces custom.limit_per_order metafield on product page and cart.
 * Limits are stored as line item property _limit_per_order and surfaced as
 * max attributes on quantity inputs in Liquid templates.
 */
(function () {

  // ── Helpers ───────────────────────────────────────────────────────────────

  function getMax(input) {
    const max = parseInt(input.getAttribute('max'));
    return isNaN(max) ? null : max;
  }

  function capToMax(input) {
    const max = getMax(input);
    if (max === null) return false;
    const val = parseInt(input.value);
    if (val > max) {
      input.value = max;
      return true;
    }
    return false;
  }

  function flashNotice(input, message) {
    const id = 'sbw-limit-notice-' + (input.id || Math.random().toString(36).slice(2));
    let el = document.getElementById(id);
    if (!el) {
      el = document.createElement('span');
      el.id = id;
      el.style.cssText = [
        'display:inline-block',
        'color:#c6a75e',
        'font-size:12px',
        'letter-spacing:.5px',
        'margin-left:8px',
        'vertical-align:middle',
      ].join(';');
      const ref = input.closest('product-quantity, .quantity-selector-holder');
      if (ref) ref.appendChild(el);
    }
    el.textContent = message;
    clearTimeout(el._timer);
    el._timer = setTimeout(() => el.remove(), 2500);
  }

  async function fetchCart() {
    const res = await fetch('/cart.json');
    return res.json();
  }

  // ── Product page: check cart qty before allowing add-to-cart ──────────────

  function initProductPageLimit() {
    const form = document.querySelector('[data-type="add-to-cart-form"]');
    if (!form) return;

    const limitInput = form.querySelector('input[name="properties[_limit_per_order]"]');
    if (!limitInput) return;

    const limit = parseInt(limitInput.value);
    if (!limit || isNaN(limit)) return;

    const cartQtyByVariant = {};

    function getVariantId() {
      const el = form.querySelector('input[name="id"]');
      return el ? parseInt(el.value) : null;
    }

    function getQtyInputValue() {
      const el = form.querySelector('.qty-selector');
      return el ? Math.max(1, parseInt(el.value) || 1) : 1;
    }

    function showErrorBanner(msg) {
      let banner = document.getElementById('sbw-atc-limit-banner');
      if (!banner) {
        banner = document.createElement('p');
        banner.id = 'sbw-atc-limit-banner';
        banner.style.cssText = [
          'color:#a8893e',
          'background:#fff8ee',
          'border:1px solid #c6a75e',
          'font-size:13px',
          'letter-spacing:.5px',
          'padding:8px 14px',
          'border-radius:2px',
          'margin:0 0 10px',
        ].join(';');
        const atcBtn = form.querySelector('[data-js-product-add-to-cart]');
        if (atcBtn) atcBtn.parentNode.insertBefore(banner, atcBtn);
        else form.appendChild(banner);
      }
      banner.textContent = msg;
      banner.style.display = 'block';
    }

    function hideErrorBanner() {
      const banner = document.getElementById('sbw-atc-limit-banner');
      if (banner) banner.style.display = 'none';
    }

    function updateProductPageState() {
      const variantId = getVariantId();
      if (!variantId) return;
      const existingQty = cartQtyByVariant[variantId] || 0;
      const remaining = limit - existingQty;

      const qtyInput = form.querySelector('.qty-selector');
      const submitBtn = form.querySelector('[data-js-product-add-to-cart]');

      if (remaining <= 0) {
        if (qtyInput) {
          // Keep max at the real limit so any flash notice reads "Max N per order", not "Max 0"
          qtyInput.setAttribute('max', String(limit));
          // Keep value at 1 (showing 0 is confusing); submit is blocked by the interceptor
          if (parseInt(qtyInput.value) < 1) qtyInput.value = 1;
        }
        if (submitBtn) submitBtn.disabled = true;
        showErrorBanner('You already have the maximum (' + limit + ') in your cart.');
      } else {
        if (qtyInput) {
          qtyInput.setAttribute('max', String(remaining));
          const cur = parseInt(qtyInput.value) || 1;
          if (cur > remaining) qtyInput.value = remaining;
          if (cur < 1) qtyInput.value = 1;
        }
        if (submitBtn) submitBtn.disabled = false;
        hideErrorBanner();
      }
    }

    fetchCart().then(cart => {
      cart.items.forEach(item => {
        cartQtyByVariant[item.variant_id] = (cartQtyByVariant[item.variant_id] || 0) + item.quantity;
      });
      updateProductPageState();
    });

    const variantInput = form.querySelector('input[name="id"]');
    if (variantInput) {
      new MutationObserver(updateProductPageState).observe(variantInput, { attributes: true, attributeFilter: ['value'] });
      variantInput.addEventListener('change', updateProductPageState);
    }

    // Intercept ATC submit in capture phase — runs before the theme's handler
    form.addEventListener('submit', function (e) {
      const variantId = getVariantId();
      if (!variantId) return;
      const existingQty = cartQtyByVariant[variantId] || 0;
      const qtyToAdd = getQtyInputValue();

      if (existingQty + qtyToAdd > limit) {
        e.preventDefault();
        e.stopImmediatePropagation();
        const remaining = Math.max(0, limit - existingQty);
        showErrorBanner(
          remaining > 0
            ? 'You can only add ' + remaining + ' more (limit: ' + limit + ' per order).'
            : 'You already have the maximum (' + limit + ') in your cart.'
        );
        return;
      }

      // Optimistically update so a rapid double-submit is also blocked
      cartQtyByVariant[variantId] = (cartQtyByVariant[variantId] || 0) + qtyToAdd;
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductPageLimit);
  } else {
    initProductPageLimit();
  }


  // ── Cart: plus button — block at max (capture phase) ──────────────────────

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('cart-product-quantity .qty-plus');
    if (!btn) return;
    const cpq = btn.closest('cart-product-quantity');
    if (!cpq) return;
    const input = cpq.querySelector('.qty');
    if (!input) return;
    const max = getMax(input);
    if (max === null) return;
    if (parseInt(input.value) >= max) {
      e.preventDefault();
      e.stopImmediatePropagation();
      flashNotice(input, 'Max ' + max + ' per order');
    }
  }, true);

  // Cart: typed input — cap before component reads it (capture phase)
  document.addEventListener('change', function (e) {
    const cpq = e.target.closest('cart-product-quantity');
    if (!cpq) return;
    if (!e.target.classList.contains('qty')) return;
    const capped = capToMax(e.target);
    if (capped) flashNotice(e.target, 'Max ' + getMax(e.target) + ' per order');
  }, true);

  // ── Cart page form submit — block if any qty input exceeds its max ─────────

  document.addEventListener('submit', function (e) {
    const cartFormEl = e.target.closest('cart-form');
    if (!cartFormEl) return;
    const form = cartFormEl.querySelector('form#cart');
    if (!form || e.target !== form) return;

    let blocked = false;
    form.querySelectorAll('input.qty-selector[max]').forEach(function (input) {
      const max = getMax(input);
      if (max === null) return;
      const val = parseInt(input.value);
      if (val > max) {
        input.value = max;
        blocked = true;
      }
    });

    if (blocked) {
      e.preventDefault();
      e.stopImmediatePropagation();
      let banner = document.getElementById('sbw-cart-page-banner');
      if (!banner) {
        banner = document.createElement('p');
        banner.id = 'sbw-cart-page-banner';
        banner.style.cssText = [
          'color:#a8893e',
          'background:#fff8ee',
          'border:1px solid #c6a75e',
          'font-size:13px',
          'letter-spacing:.5px',
          'padding:8px 14px',
          'border-radius:2px',
          'margin:0 0 14px',
          'text-align:center',
        ].join(';');
        form.insertBefore(banner, form.firstChild);
      }
      banner.textContent = 'One or more quantities have been reduced to the per-order limit. Please review and try again.';
      banner.style.display = 'block';
    }
  }, true);

  // Product page qty plus button — cap after ProductQuantity component increments
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('product-quantity .qty-plus');
    if (!btn) return;
    if (btn.closest('cart-product-quantity')) return;
    const pq = btn.closest('product-quantity');
    if (!pq) return;
    const input = pq.querySelector('.qty-selector');
    if (!input) return;
    const max = getMax(input);
    if (max === null) return;
    setTimeout(() => {
      const capped = capToMax(input);
      if (capped) flashNotice(input, 'Max ' + max + ' per order');
    }, 0);
  });

  // Product page qty text input — cap on change
  document.addEventListener('change', function (e) {
    if (!e.target.classList.contains('qty-selector')) return;
    if (e.target.closest('cart-product-quantity')) return;
    const capped = capToMax(e.target);
    if (capped) flashNotice(e.target, 'Max ' + getMax(e.target) + ' per order');
  });

})();
